import React from "react";
import { StickyNote, Plug } from "lucide-react";
import PageHeader from "@/components/admin/PageHeader";
import EnableFeatureCard from "@/components/admin/EnableFeatureCard";
import HowThisWorks from "@/components/admin/HowThisWorks";

export default function DataSourceNotion() {
    return (
        <div className="p-10 max-w-5xl">
            <PageHeader
                eyebrow="Data sources"
                title="Notion"
                description="Connect Notion pages and databases as a source of truth for Priya."
                testid="page-notion"
            />
            <EnableFeatureCard
                title="Connect your Notion workspace"
                description="Authorise Priya to read selected Notion pages and keep your knowledge base in sync as Notion updates."
                icon={StickyNote}
                actionLabel="Connect Notion"
                testid="notion-connect"
                feature="notion"
            />
            <HowThisWorks
                steps={[
                    "Click Connect Notion and authorise the Orchid integration in your workspace.",
                    "Pick the pages or databases you want Priya to learn from.",
                    "Priya re-syncs automatically whenever you update a connected Notion page.",
                ]}
            />
        </div>
    );
}
